import { getApiBaseUrl } from "../runtime/apiBaseUrl";

const LEGACY_PORTAL_SESSION_KEYS = Object.freeze([
    "portal-session-token",
]);

function clearLegacyPortalState() {
    LEGACY_PORTAL_SESSION_KEYS.forEach((key) => {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
    });
}

export async function getValidatedBrowserSession() {
    clearLegacyPortalState();

    const response = await fetch(`${getApiBaseUrl()}/api/auth/v2/me`, {
        method: "GET",
        credentials: "include",
        headers: {
            Accept: "application/json",
        },
    });

    const payload = await response.json().catch(() => ({}));

    if (payload?.authenticated === false) {
        return null;
    }

    if (!response.ok) {
        const error = new Error(payload?.message || "Unable to validate the current auth session.");
        error.status = response.status;
        error.code = payload?.code || null;
        throw error;
    }

    return payload;
}

export async function signOutBrowserSession() {
    try {
        await fetch(`${getApiBaseUrl()}/api/auth/v2/logout`, {
            method: "POST",
            credentials: "include",
            headers: {
                Accept: "application/json",
            },
        });
    } finally {
        clearLegacyPortalState();
    }
}
